import { Badge } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Icon } from 'ui';
import { StyledSidebarMenuItem } from './style';

interface SidebarMenuItemProps {
  labelId: string;
  url: string;
  icon: string;
  badgeCount?: number;
  active?: boolean;
  isLink?: boolean;
  openCloseDrawer?: () => void;
}

const SidebarMenuItem = ({
  labelId,
  url,
  icon,
  badgeCount = 0,
  active = false,
  isLink = false,
  openCloseDrawer,
}: SidebarMenuItemProps) => {
  const navigate = useNavigate();

  const content = (
    <>
      {<Icon name={icon} />}
      <span className={'sider-menu-item-label'}>{labelId}</span>
      {badgeCount > 0 && <Badge count={badgeCount} offset={[10, 0]} />}
    </>
  );

  if (isLink) {
    return (
      <a href={url} className={`custom-menu-item ${active ? 'active' : ''}`}>
        {content}
      </a>
    );
  }

  return (
    <StyledSidebarMenuItem
      className={`custom-menu-item ${active ? 'active' : ''}`}
      onClick={
        isLink
          ? () => {
              openCloseDrawer && openCloseDrawer();
            }
          : () => {
              openCloseDrawer && openCloseDrawer();
              navigate(url);
            }
      }
    >
      {content}
    </StyledSidebarMenuItem>
  );
};

export default SidebarMenuItem;
